import { Col, Container, Image, Row } from "react-bootstrap";
import styles from "./style.module.scss";
import { useEffect, useRef } from "react";
import { parseHtml, toWebp } from "../../../utils/common";

let baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;

const Process = (prop) => {
  const divRef = useRef(null);
  let data = prop.block;
  useEffect(() => {
    const imageUrl = baseUrl + data?.background?.data?.attributes?.url;

    divRef.current.style.backgroundImage = `url(${imageUrl})`;
  }, [data]);

  return (
    <section
      ref={divRef}
      className={`${styles["process-new-section"]} ${styles["technology-process-new-section"]} blue-bg-margin`}
    >
      <Container className={styles["container"]}>
        <Row className={styles["card-border-line"]}>
          <Col lg={12}>
            <div className={styles["process-new-content"]}>
              <h2 className="text-white">{data?.title}</h2>
              <p className="text-white font-medium">{data?.short_title}</p>

            </div>
          </Col>
          {data?.steps?.map((step, index) => (

            <Col lg={4} md={4} key={step.id} className={`${++index % 3 !== 0 ? '' : styles["card-border-line-2"]} ${styles.numbercard} ${styles["card-border-line-1"]}`}>
              <div
                className={`${styles["process-new-card"]} ${index % 3 !== 0 ? styles["process-new-card-green"] : ""} border-2 border-color bg-white`}
              >
                <div className={styles["process-heading"]}>
                  <div className={styles["next-project-left-content"]}>
                    <div className={`${styles["next-project-profile"]} border-color border-2 bg-white`}>
                      <Image
                        src={toWebp(
                          `${baseUrl}${step?.image?.data?.attributes?.url}`
                        )}
                        alt={step?.image?.data?.attributes?.name}
                      />
                    </div>
                    <span></span>
                  </div>
                </div>
                <div className={`${styles["process-body"]} text-normal font-regular text-black`}>
                  <h3 className="text-medium text-black font-semibold">{step?.title}</h3>
                  {parseHtml(step?.description)}
                </div>
                <a
                  className={`btn ${styles["btn-steps"]} ${styles["remove-border"]}`}
                >
                  <span className="">{step?.numbers}</span>
                </a>
              </div>
            </Col>

          ))}
        </Row>



        <div
          style={{
            marginTop: "70px",

            padding: "50px 0  0px 0"
          }}
          className={`text-center d-flex justify-content-center ${styles["mobile-none-css"]} `}

        >
          {data?.cta &&
            <>
              <a className={`btn ${styles["process-btn"]} btn btn-secondary decoration-none text-primary`} href={data?.cta?.href} >{data?.cta?.label}</a>
            </>}

        </div>
      </Container>





    </section>
  );
};

export default Process;
